import { StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import moment from 'moment'
import GeneratePDF from '../../../common/GeneratePDF'
import { useTheme } from '@mui/material'
import { ownBookingSummaryColumn, pdfHeaderColumn } from './BookingConstants'

export const OwnBookingSummaryLargePdf = ({ fromDate, toDate, tableData, headerData, selReportView, cargoSettingFilterData }) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const styles = StyleSheet.create({
    dataRow: {
      flexDirection: 'row',
      borderBottom: '1pt solid #A6A8AB',
    },
    dataCell: {
      flex: 1,
      fontSize: '12px',
      fontWeight: 500,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    headerCell: {
      backgroundColor: '#BFE1FF',
      flex: 1,
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    subHeadingRow: {
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    dataSubRow: {
      textAlign: 'right',
      borderBottom: '1pt solid #A6A8AB',
      backgroundColor: '#f1f9ff',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  })
  return (
    <GeneratePDF
      width={'100%'}
      height={'440px'}
      size={[1190, 1400]}
      reportName={'Own Booking Summary Report'}
      generateDate={`${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
      reportView={`Report View: ${selReportView?.ReportView}`}
      isSubHeading={true}
      title={'Own Booking Summary Report'}
    >
      <View style={{ border: '1pt solid #A6A8AB' }}>
        <View style={styles.dataRow}>
          {pdfHeaderColumn?.map((val) => (
            <Text style={styles.headerCell}>{val?.exportHead}</Text>
          ))}
        </View>
        <View style={{ flexDirection: 'row' }}>
          <Text style={styles.dataCell}>{headerData?.sourceCity}</Text>
          <Text style={styles.dataCell}>{headerData?.sourceBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.sourceBranchUser}</Text>
          <Text style={styles.dataCell}>{headerData?.destCity}</Text>
          <Text style={styles.dataCell}>{headerData?.destBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
          <Text style={styles.dataCell}>{headerData?.trnsType}</Text>
          <Text style={styles.dataCell}>{headerData?.status}</Text>
        </View>
      </View>
      <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
        <View style={styles.dataRow}>
          {ownBookingSummaryColumn?.map((i, index) =>
            cargoSettingFilterData == 0 && i.headerName === 'Ham. Chrg' ? (
              ''
            ) : (
              <Text style={{ ...styles.headerCell, textAlign: index < 2 ? 'left' : 'right', minWidth: i.minWidth }}>{i.headerName}</Text>
            )
          )}
        </View>
        <View style={{ border: '1pt solid #A6A8AB' }}>
          {tableData?.length < 1 ? (
            <>
              <View style={styles.dataRow}>
                <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                  No results found. Please refine your search parameters and search again.
                </Text>
              </View>
            </>
          ) : (
            <>
              {tableData?.map((item, index) => {
                return (
                  <>
                    <View style={styles.dataSubRow}>
                      {Object.keys(item).length == 12 ? (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '190px',
                              textAlign: 'right',
                            }}
                          >
                            {item.PayType}{' '}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.LRCount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {' '}
                            {item.ItemUnits}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.Freight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.CartageAmount}
                          </Text>
                          {cargoSettingFilterData == 1 && (
                            <Text
                              style={{
                                ...styles.dataCell,
                                paddingLeft: '20px',
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '80px',
                                textAlign: 'right',
                              }}
                            >
                              {item.HamaliCharges}{' '}
                            </Text>
                          )}
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.Valuation}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OtherCharges}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.BookingGST}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.Amount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.RefundAmt}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              paddingLeft: '20px',
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '80px',
                              textAlign: 'right',
                            }}
                          >
                            {item.NetAmount}
                          </Text>
                        </>
                      ) : (
                        <>
                          <Text style={{ ...styles.dataCell, textAlign: 'left', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>{item.SN}</Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'left', fontSize: '12px',backgroundColor:"white", minWidth: '100px' }}>{item.PayType}</Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>{item.LRCount}</Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                            {item.ItemUnits}
                          </Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>{item.Freight}</Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                            {item.CartageAmount}
                          </Text>
                          {cargoSettingFilterData == 1 && (
                            <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                              {item.HamaliCharges}
                            </Text>
                          )}
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                            {item.Valuation}
                          </Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                            {item.OtherCharges}
                          </Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                            {item.BookingGST}
                          </Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>{item.Amount} </Text>

                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                            {item.RefundAmt}
                          </Text>
                          <Text style={{ ...styles.dataCell, textAlign: 'right', fontSize: '12px',backgroundColor:"white", minWidth: '80px' }}>
                            {item.NetAmount}
                          </Text>
                        </>
                      )}
                    </View>
                  </>
                )
              })}
            </>
          )}
        </View>
      </View>
    </GeneratePDF>
  )
}
export const OwnBookingDetailedLargePdf = ({ fromDate, toDate, tableData, headerData, selReportView, cargoSettingFilterData }) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const styles = StyleSheet.create({
    dataRow: {
      flexDirection: 'row',
      borderBottom: '1pt solid #A6A8AB',
    },
    dataCell: {
      flex: 1,
      fontSize: '12px',
      fontWeight: 500,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    headerCell: {
      backgroundColor: '#BFE1FF',
      flex: 1,
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    subHeadingRow: {
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    dataSubRow: {
      textAlign: 'right',
      borderBottom: '1pt solid #A6A8AB',
      backgroundColor: '#f1f9ff',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    isHeading: {
      paddingVertical: 8,
      fontSize: '12px',
      flex: 1,
      borderBottom: '1pt solid #A6A8AB',
      color: '#444444',
      backgroundColor: '#bfe1ff',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  })
  return (
    <GeneratePDF
      width={'100%'}
      height={'440px'}
      size={[2252, 2500]}
      reportName={'Own Booking Summary Report'}
      generateDate={`${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
      reportView={`Report View: ${selReportView?.ReportView}`}
      isSubHeading={true}
      title={'Own Booking Summary Report'}
    >
      <View style={{ border: '1pt solid #A6A8AB' }}>
        <View style={styles.dataRow}>
          {pdfHeaderColumn?.map((val) => (
            <Text style={styles.headerCell}>{val?.exportHead}</Text>
          ))}
        </View>
        <View style={{ flexDirection: 'row' }}>
          <Text style={styles.dataCell}>{headerData?.sourceCity}</Text>
          <Text style={styles.dataCell}>{headerData?.sourceBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.sourceBranchUser}</Text>
          <Text style={styles.dataCell}>{headerData?.destCity}</Text>
          <Text style={styles.dataCell}>{headerData?.destBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
          <Text style={styles.dataCell}>{headerData?.trnsType}</Text>
          <Text style={styles.dataCell}>{headerData?.status}</Text>
        </View>
      </View>
      <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
        <View style={{ border: '1pt solid #A6A8AB' }}>
          {tableData?.length < 1 ? (
            <>
              <View style={styles.dataRow}>
                <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                  No results found. Please refine your search parameters and search again.
                </Text>
              </View>
            </>
          ) : (
            <>
              {tableData?.map((item, index) => {
                return (
                  <>
                    <View key={`SHRT-${index}`} style={styles.dataSubRow}>
                      {item.isTotal ? (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '1170px',
                            }}
                          >
                            {item.srNo}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '130px',
                              textAlign:"left"
                            }}
                          >
                            {item.Quantity}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '130px',
                            }}
                          >
                            {item.Freight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '130px',
                            }}
                          >
                            {item.CartageAmount}
                          </Text>
                          {cargoSettingFilterData == 1 && (
                            <Text
                              style={{
                                ...styles.dataCell,
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '130px',
                              }}
                            >
                              {item.HamaliCharges}
                            </Text>
                          )}
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '130px',
                            }}
                          >
                            {item.Valuation}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '130px',
                            }}
                          >
                            {item.OtherCharges}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '130px',
                            }}
                          >
                            {item.BookingGST}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,
                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '130px',
                              
                            }}
                          >
                            {item.NetAmount}
                          </Text>
                        </>
                      ) : item.isSubHeading ? (
                        <>
                          <View key={`SHRT-${index}`} style={styles.dataSubRow}>
                            <Text style={{...styles.subHeadingRow,width:"736px",textAlign:"left"}}>{item.srNo}</Text>

                            <Text
                              style={{...styles.subHeadingRow,width:"736px"}}
                            >
                              {item.PayType}
                            </Text>
                            <Text style={{...styles.subHeadingRow,width:"736px"}}>{item.CartageAmount}</Text>
                          </View>
                        </>
                      ) : item.isHeading ? (
                        <>
                          <View key={`SHRT-${index}`} style={styles.dataSubRow}>
                          {Object.keys(item)
                            .filter((val) =>
                              val !== 'isHeading' && val !== 'HamaliCharges' ? true : cargoSettingFilterData == 1 && val !== 'isHeading').map((i, index) => (
                              <Text
                              style={{...styles.isHeading,minWidth:"130px",textAlign:index<=9?"left":"right"}}
                              >
                                {item[i]}
                              </Text>
                            ))}
                          </View>
                        </>
                      ) : (
                        <>
                          <View key={`SHRT-${index}`} style={styles.dataSubRow}>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>{item.SN}</Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              <Text style={{ color: '#0086ff' }}>{item.LRNO}</Text> <br />
                              <Text>{item.ManualLRNo}</Text>
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.DestCityName} <br />
                              {item.DestBranchName}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.BkgDtTime} <br />
                              {item.UserBooked}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.Sender} <br />
                              {item.SenderGSTN}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.RecName} <br />
                              {item.RecGSTN}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.PayType}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.Description}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.STATUS}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'left', minWidth: '130px' }}>
                              {item.ConsignmentType} <br/>
                              {item.Quantity}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'right', minWidth: '130px' }}>
                              {item.Freight}
                            </Text>

                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'right', minWidth: '130px' }}>
                              {item.CartageAmount}
                            </Text>
                            {cargoSettingFilterData === 1 && (
                              <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'right', minWidth: '130px' }}>
                                {item.HamaliCharges}
                              </Text>
                            )}
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'right', minWidth: '130px' }}>
                              {item.Valuation}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'right', minWidth: '130px' }}>
                              {item.OtherCharges}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'right', minWidth: '130px' }}>
                              {item.BookingGST}
                            </Text>
                            <Text style={{ ...styles.dataCell, fontSize: '12px', backgroundColor:"white", textAlign: 'right', minWidth: '130px' }}>
                              {item.NetAmount}
                            </Text>
                          </View>
                        </>
                      )}
                    </View>
                  </>
                )
              })}
            </>
          )}
        </View>
      </View>
    </GeneratePDF>
  )
}
